module.exports = __webpack_public_path__ + "img/loadingbg.8046f1b7.png";